import type { FaireProductEntity } from "../../entity_types/product";

export const p_fs4p74vzen: FaireProductEntity = {
  token: "p_fs4p74vzen",
  type: "product",
  name: "Detangler Frizz-Taming Spray 8 oz",
  brandToken: "b_3z46kjdoak",
  brandName: "Plant Therapy",
  imageUrl:
    "https://cdn.faire.com/fastly/6293be5d648b62799b8a69ba1db80a7b2ddfb0e493b0b045ff96e8c31e38c874.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91cc1e8cadc36176cd36a6ce4bf937eb464c8a3db8fe1e02f6db234715cbda6f.webp",
    "https://cdn.faire.com/fastly/4453bb83d4a93e609052f96bd5f4e47672b4d82e7e5ceed25447ae55a0d909f3.jpeg",
    "https://cdn.faire.com/fastly/c5c5cc707bad08babe4a22fac0f579ccd3230eb051f24fee1248505004d30718.webp",
    "https://cdn.faire.com/fastly/3de6a48c69fdba1b783096e661631b9a4ad899a3946375b53805a3f0dc97d6a3.jpeg",
    "https://cdn.faire.com/fastly/def0423199e67fefcfae6e35df6d6de57e697e4ea5a4ae91523ff57818a407e4.webp",
    "https://cdn.faire.com/fastly/0b4f7e92fa0559f354dcc38e909dbf9d33cd98568dfe11f5f1d862a58a2a911c.jpeg",
    "https://cdn.faire.com/fastly/02144cd87c1918ccfde0c15d9f79f07643c38c9223401004cec7a134da97dc16.webp",
    "https://cdn.faire.com/fastly/528c800194b7be28496dcdf2bfeb8f05046dc790ee5da698dcea485621365ee2.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Tame tangles and tough tresses for manageable hair that is soft, shiny, and smooth. Great for children, this gentle detangler spray makes after-bath brushing a breeze and reduces breakage damage caused by pulling and tugging on unruly locks. Plus, its uplifting natural scent comprises hair-loving essential oils that help soothe scalp irritation and add a lustrous shine. Easily brush through knots and messes with this lightweight formula that won't weigh down hair as it softens and separates stubborn strands. Conditioning plant-based ingredients like Argan, Jojoba, and Aloe Vera provide an instant burst of nourishment while helping to keep hair looking and feeling healthy.",
  tags: [],
  msrpDollars: 16.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:45.625Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
